/**
 * Page header for chapter home pages (Your TTC Hub, Your Pregnancy Hub, etc.)
 */
import { pageTitleH1 } from '../../designSystem';

const FONT = '"Plus Jakarta Sans", -apple-system, sans-serif';

export default function HomePageHeader({ pageTitle, theme, statusPillText, onSignUp }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: 24,
        flexWrap: 'wrap',
        gap: 12,
      }}
    >
      <div>
        <h1 style={{ ...pageTitleH1, marginTop: 0 }}>
          {pageTitle}
        </h1>
        {statusPillText && <p style={{ fontSize: 13, color: 'var(--muted)', margin: 0 }}>{statusPillText}</p>}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {statusPillText && (
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: theme.accentText,
              background: theme.accentBg,
              border: `1px solid ${theme.accent}40`,
              borderRadius: 999,
              padding: '6px 14px',
            }}
          >
            {statusPillText}
          </span>
        )}
        <button
          type="button"
          onClick={() => onSignUp?.('/signup')}
          style={{
            fontFamily: FONT,
            fontSize: 13,
            fontWeight: 700,
            background: theme.accent,
            color: 'white',
            border: 'none',
            borderRadius: 999,
            padding: '10px 20px',
            cursor: 'pointer',
          }}
        >
          Sign up
        </button>
      </div>
    </div>
  );
}
